// TanStack Query client configuration

import { QueryClient } from '@tanstack/react-query';
import { ApiRequestError } from '@/lib/http';
import { registerHouseholdItemMutationDefaults } from '@/features/household-items/mutationDefaults';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      // Persisted entries must outlive hydration; the 5-min default would evict
      // them before the restored cache is read. 24h matches the persister maxAge.
      gcTime: 24 * 60 * 60 * 1000,
      // Refetch on window focus so collaborative surfaces pick up a partner's
      // changes when the user returns to the tab. Set explicitly (rather than
      // relying on React Query's implicit `true` default) to make the freshness
      // contract a documented decision (#408). The global 5-minute staleTime
      // gates this: queries that want an on-focus refetch to always fire (Lists,
      // Agenda) override `staleTime: 0` at the call site.
      refetchOnWindowFocus: true,
      retry: (failureCount, error) => {
        // Don't retry on auth errors
        if (error instanceof ApiRequestError && (error.status === 401 || error.status === 403)) {
          return false;
        }
        // Retry up to 3 times for other errors
        return failureCount < 3;
      },
    },
  },
});

// Registered at module load (before hydration/resumePausedMutations runs in
// App.tsx) so any Lists mutation paused before a reload can replay once the
// app comes back online.
registerHouseholdItemMutationDefaults(queryClient);
